import { type UnwrapRef, ref } from "vue";

export type tableColumn<SK extends string = string> = {
  title: string;
  key: string;
  sortKey?: SK;
  display?: boolean;
  print?: boolean;
  export?: boolean;
};

export default function useTableSort<SK extends string, T extends tableColumn<SK>>(
  columns: T[] | readonly T[]
) {
  const currentSort = ref<{ key: SK; asc: boolean }>({
    key: (columns.find((i) => i.sortKey)?.sortKey as any) || "",
    asc: true
  });

  const setSort = (sortKey: UnwrapRef<SK>, asc?: boolean) => {
    if (asc !== undefined) {
      currentSort.value = {
        key: sortKey,
        asc
      };
    } else if (sortKey === currentSort.value.key) {
      currentSort.value.asc = !currentSort.value.asc;
    } else {
      if (sortKey)
        currentSort.value = {
          key: sortKey,
          asc: true
        };
    }
  };

  const resetSort = <SK extends string, T extends tableColumn<SK>>(columns: T[] | readonly T[]) => {
    currentSort.value = {
      key: columns[0]?.key || ("" as any),
      asc: true
    };
  };

  return { currentSort, setSort, resetSort };
}
